import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import es from './locales/es.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import zh from './locales/zh.json';
import it from './locales/it.json';
import ru from './locales/ru.json';

const resources = {
  en: en,
  es: es,
  de: de,
  fr: fr,
  zh: zh,
  it: it,
  ru: ru
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'de', 'fr', 'zh', 'it', 'ru'],
    interpolation: {
      escapeValue: false 
    }
  });

export default i18n;
